import { formatDateMDYYYY ,formatyyyymmdd, getDateTimeZoneHandled } from '../../utils/dateUtil';
import {convertTens, amountFormatter } from '../../utils/formatter';


const calculateServiceCount = (data, year) => {
  let totalServicesCompleted;
  let servicesRemaining;
  let lastServiceDate = 'N/A';
  if (year === (parseInt((new Date()).getFullYear()))) {
    totalServicesCompleted = convertTens(data.TotalServicesCompleted);
    servicesRemaining = convertTens(data.ServicesRemaining);
    lastServiceDate = formatDateMDYYYY(data.woMostRecentComplDate);
  }
  else {
    let invoice = filterInvoice(data.Invoices, year);
    totalServicesCompleted = '00';
    servicesRemaining = '00';
    if (invoice.length > 0) {
      totalServicesCompleted = convertTens(((invoice).filter(invoice => invoice.svcReserviceFlag === 'N')).length);
      lastServiceDate = formatDateMDYYYY(invoice[0].workOrderSvcDate);
    }
  }
  if (!lastServiceDate) {
    lastServiceDate = 'N/A';
  }
  return { totalServicesCompleted, servicesRemaining, lastServiceDate };
};

const filterInvoice = (invoices, year) => {
  if (!invoices) return [];
  let filteredInvoice = invoices.filter(invoice => ((getDateTimeZoneHandled(invoice.workOrderSvcDate)).getFullYear() === parseInt(year)));
  filteredInvoice = (filteredInvoice.sort(function (a, b) {
    return new Date(a.workOrderSvcDate) - new Date(b.workOrderSvcDate);
  })).reverse();
  return filteredInvoice;
};

const filterServiceAgeement = (serviceDetails, year) => {
  let salesAgreements = [];
  if (serviceDetails && serviceDetails.SalesAgreements)
    salesAgreements = serviceDetails.SalesAgreements.filter((salesAgrrements) => (!(calculateServiceCount(salesAgrrements, year).totalServicesCompleted === '00' && calculateServiceCount(salesAgrrements, year).servicesRemaining === '00')));
  return salesAgreements;
};

const discCalculate = salesAgreements => {
  let prePaydiscFlag = false;
  let discAmount = 0;
  try {
    const discSaleAgreement = salesAgreements.PrePay[0].yiaDiscAmt;
    discAmount =-1 *( discSaleAgreement);
    if(discAmount>0){
      prePaydiscFlag=true;
    }
  } catch {
    //continue with false values
  }
  return { prePaydiscFlag, discAmount };
};

const toolTipCalculate = (data, labels) =>{
  let tooltip;
  if(data.ServiceAgreementType === 'PrePay'){
    if (data.prepayDspSvcCntFlag === 'Y') {
      if(labels){
        tooltip = labels.tooltipheading1?.toString() + ' ' + data.prepayDspSvcCnt.toString();
      }
    }
    else {
      if(labels){
        tooltip = labels.tooltipheading2?.toString() + ' ' + (data.arBalance * -1).toString();
      }
    }
  }
  return tooltip;
};

const easyPayAmt = (data, year) => {
  let eDate = 'N/A';
  let eDollar;
  let eCent;
  if (data.Invoices) {
    const invoice = filterInvoice(data.Invoices, year)[0];
    if (invoice) {
      eDate = formatDateMDYYYY(invoice.invoiceDate);
      if (!eDate) {
        eDate = 'N/A';
      }
      eDollar = amountFormatter(invoice.invoiceAmount);
      eCent = eDollar.cents;
      eDollar = eDollar.dollars;
    }
  }
  return { eDate, eDollar, eCent };
};



const dateArray= (dateOption) =>{ 
  let date = new Date();
  const months =  ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  let day = date.getDay();
  let toDay=new Date(date);
  let dateMatrix=[];
  date.setDate( date.getDate()-day);
  let startDate=new Date(date);
  date.setDate( date.getDate()+21);
  let endDate=new Date(date);
  let startMonth= months[startDate.getMonth()];
  let endMonth= months[endDate.getMonth()];
  for (let j = 0; j < 21; j=j+7) {
    let arrayWeek=[];
    for(let i=j; i<7+j ; i++){
      let tmpDate=new Date(startDate);
      let dateClass='fc-future';
      tmpDate.setDate( tmpDate.getDate() + i);
      let dayName = tmpDate.toString().split(' ')[0].toLowerCase();
      let dateNumber = tmpDate.getDate(); 
      let date= formatyyyymmdd(tmpDate);
      if (tmpDate.getTime() < toDay.getTime()) dateClass='fc-past';
      else if (tmpDate.getTime() === toDay.getTime()) dateClass='fc-today'; 

      dateOption.forEach((option) => {
        if(option===date) 
          dateClass='fc-available-day';
      });
      arrayWeek.push({dayName,dateNumber,date,dateClass});
    }
    dateMatrix.push(arrayWeek);
  }


  return {startMonth,dateMatrix,endMonth};
};

export {
  calculateServiceCount,
  filterInvoice,
  filterServiceAgeement,
  discCalculate,
  easyPayAmt,
  toolTipCalculate,
  dateArray
};